import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the withMakes filter
 * @param {boolean} withMakes - Whether to filter by makes
 */
export const setWithMakes = (withMakes) => {
  searchPageStore.setState({ withMakes })
}

/**
 * Sets the threeDPrintVerified filter
 * @param {boolean} threeDPrintVerified - Whether to filter by 3D print verified
 */
export const setThreeDPrintVerified = (threeDPrintVerified) => {
  searchPageStore.setState({ threeDPrintVerified })
}

/**
 * Sets the multiColor filter
 * @param {boolean} multiColor - Whether to filter by multi-color
 */
export const setMultiColor = (multiColor) => {
  searchPageStore.setState({ multiColor })
}

/**
 * Clears all 3D print only filters
 */
export const clearThreeDprintOnly = () => {
  searchPageStore.setState({
    withMakes: DEFAULT_STATE.withMakes,
    threeDPrintVerified: DEFAULT_STATE.threeDPrintVerified,
    multiColor: DEFAULT_STATE.multiColor,
  })
}
